module.exports = __webpack_public_path__ + "img/logo.48173aa1.svg";